<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('meb_ylsy')"
                        :isColumns="true"
                        :is-import-button="checkPermission('dailycourseschedule_mebylsyinstructorcourseloadimport')"
                        @import-button-click="importData"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('meb_ylsy')"
                              :isColumns="true"
                              :is-import-button="checkPermission('dailycourseschedule_mebylsyinstructorcourseloadimport')"
                              @import-button-click="importData"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
                              :exportExcel="checkPermission('dailycourseschedule_mebylsyinstructorcourseloadreport')"
                              @exportExcel="exportExcel"
            >
                <ValidationObserver ref="formModalValidate">
                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('teaching_staff')">
                                <staff-auto-complete v-model="datatable.queryParams.filter.instructor_id"></staff-auto-complete>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('start_date')">
                                <select-date v-model="datatable.queryParams.filter.date_greater_than" />
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="6">
                            <b-form-group :label="$t('end_date')">
                                <select-date v-model="datatable.queryParams.filter.date_smaller_than" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="importFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('import').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <import-form @successProcess="importFormSuccess" v-if="formProcess == 'import'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    //Service
    import InstructorCourseLoadService from '@/services/InstructorCourseLoadService';

    //Other
    import qs from 'qs';
    import ImportForm from "./ImportForm.vue";

    export default {
        components: {
            ImportForm,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
        },
        metaInfo() {
            return {
                title: this.$t('meb_ylsy')
            }
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: []
                        },
                        {
                            label: this.toUpperCase('academic_year'),
                            field: 'academic_year',
                            sortable: false,
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('course_name'),
                            field: 'course_name',
                            sortable: false,
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('section'),
                            field: 'section',
                            sortable: false,
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('day'),
                            field: 'day',
                            sortable: false,
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('start_time'),
                            field: 'start_time',
                            sortable: false,
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('end_time'),
                            field: 'end_time',
                            sortable: false,
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('instructor'),
                            field: 'instructor_name',
                            sortable: false,
                            hidden: false,
                            formatFn: (value, row) => {
                                return (row.instructor_name || '') + ' ' + (row.instructor_surname || '');
                            }
                        },
                        {
                            label: this.toUpperCase('classroom_name'),
                            field: 'classroom_name',
                            sortable: false,
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('campus'),
                            field: 'campus_name',
                            sortable: false,
                            hidden: false
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        methods: {
            async filter() {
                const valid = await this.$refs.formModalValidate.validate()
                if(!valid) {
                    return
                }
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams.filter
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return InstructorCourseLoadService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination?.total ?? response.data.data?.length ?? 0;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            async exportExcel() {
                const valid = await this.$refs.formModalValidate.validate()
                if(!valid) {
                    return
                }

                const config = {
                    params: {
                        ...this.datatable.queryParams.filter
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                return InstructorCourseLoadService.exportExcel(config)
                    .then((response) => {
                        const blob = new Blob([response.data], { type: response.headers['content-type'] })
                        const objectUrl = window.URL.createObjectURL(blob)
                        window.open(objectUrl)
                    })
                    .catch(e => {
                    });
            },
            // Clear
            formClear() {
                this.formId = null
                this.formProcess = null
            },
            importData() {
                this.formProcess = 'import'
                this.$refs.importFormModal.$refs.commonModal.show()
            },
            importFormSuccess() {
                this.formProcess = null;
                this.$refs.importFormModal.$refs.commonModal.hide()
            }
        }
    }
</script>
